import React, { Component } from 'react'
import generateId from '../utils/generateId'
import { data, notes1, notes2 } from './data'
import OdInput from './OdInput'
 import styles from './s.module.css'

export default class Content extends Component {
  constructor (props) {
    super(props)
    this.state = {
      od: '0'
    }
    this.handleOdChange = this.handleOdChange.bind(this)
  }

  handleOdChange (e) {
    this.setState({
      od: e.target.value
    })
  }

  render () {
    const d = data[this.props.index]
    const notes = resolveNotes(d[3], d[5])
    const val1 = resolveVal(d[2])
    const val2 = resolveVal(d[4])
    return (
      <div className={styles.subTreeItemCon}>
        <OdInput value={this.state.od} onChange={this.handleOdChange} />
        <p className={styles.conLab}>Souběh:</p>
        <ResTable v1={val1} v2={result(val1, d[2], this.props.od, this.state.od)} />
        {notes[0]}
        <p className={styles.conLab}>Křížení:</p>
        <ResTable v1={val2} v2={result(val2, d[4], this.props.od, this.state.od)} />
        {notes[1]}
      </div>
    )
  }
}

// Content.propTypes = {
//   index: PropTypes.string,
//   od: PropTypes.string
// }

const ResTable = ({v1, v2}) => (
  <table className={styles.resTab}>
    <tbody>
      <tr>
        <td>Mezi plášti:</td>
        <td>{v1}</td>
      </tr>
      <tr>
        <td>Osově:</td>
        <td>{v2}</td>
      </tr>
    </tbody>
  </table>
)

// ResTable.propTypes = {
//   v1: PropTypes.string,
//   v2: PropTypes.string
// }

const resolveVal = val => {
  if (val === -1) {
    return '-'
  }
  return new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2 }).format(val) + ' m'
}

const resolveNotes = (n1, n2) => {
  let res = [
    resolveNotes2(n1, notes1),
    resolveNotes2(n2, notes2)
  ]
  if (!res[0] && res[1]) {
    res[0] = <p className={styles.conNot}>-</p>
  }
  return res
}

const resolveNotes2 = (notes, labels) => {
  if (notes.length === 0) {
    return null
  }
  let res = []
  for (let i = 0; i < notes.length; i++) {
    res.push(<p key={generateId()} className={styles.conNot}>{labels[notes[i]]}</p>)
  }
  return res
}

const sum = (dist, od1, od2) => {
  const r2 = parseOd(od2 === '' ? '0' : od2) / 2
  const r1 = parseOd(od1 === '' ? '0' : od1) / 2
  if (isNaN(r1) || isNaN(r2)) {
    return 'není číslo'
  }
  return new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2 }).format(dist + r1 + r2) + ' m'
}

const parseOd = od => parseFloat(od.replace(',', '.'))

const result = (val, val2, od1, od2) => val === '-' ? '-' : sum(val2, od1, od2)
